import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountBoxRounded from "@mui/icons-material/AccountBoxRounded";
import {useIsMobile} from "hooks/useIsMobile";

const HelpCard = () => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <Grid item xs={12} sx={{mt: 2}}>
        <Card elevation={3}>
          <Accordion
            defaultExpanded={false} // Set to true if you want it open by default
            sx={{
              backgroundColor: "#fff",
              boxShadow: "none", // Remove default accordion shadow
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon/>}
              sx={{
                padding: 0,
                "& .MuiAccordionSummary-content": {
                  margin: 0,
                  pl: 2
                },
              }}
            >
              <AccountBoxRounded sx={{ marginRight: 1, marginTop: 0.5 }}/>
              <Typography variant="body1" sx={{fontWeight: 600}}>
                  Help
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" gutterBottom>
                For questions regarding your HDFS loan, end of loan options, or the H-D Flex Financing program, contact
                our{" "}
                <strong>
                  Flex Financing team at{" "}
                  <Link href="tel:800-717-3450" underline="hover">
                    800-717-3450
                  </Link>
                </strong>
                .
              </Typography>
              <Typography variant="body1" gutterBottom>
                For questions regarding your title or the titling process, contact our{" "}
                <strong>
                  Titles department at{" "}
                  <Link href="tel:866-433-7562" underline="hover">
                    866-433-7562
                  </Link>
                </strong>
                .
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Card>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Card elevation={3}>
        <CardContent>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <AccountBoxRounded fontSize="medium" />
            </Grid>
            <Grid item>
              <Typography variant="h6" gutterBottom>
                Help
              </Typography>
            </Grid>
          </Grid>
          <Typography variant="body1" gutterBottom>
            For questions regarding your HDFS loan, end of loan options, or the H-D Flex Financing program, contact our <strong>Flex Financing team at <Link href="tel:800-717-3450" underline="hover">800-717-3450</Link></strong>.
          </Typography>
          <Typography variant="body1" gutterBottom>
            For questions regarding your title or the titling process, contact our <strong>Titles department at <Link href="tel:866-433-7562" underline="hover">866-433-7562</Link></strong>.
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default HelpCard;
